//百果园
import Overview from './overview.vue';
import MobOverview from '@/rebuild/materials/shared/esg/mobile/MobOverview.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 